import { render, staticRenderFns } from "./PreventGreenhouse.vue?vue&type=template&id=fbb96a58&scoped=true&"
import script from "./PreventGreenhouse.vue?vue&type=script&lang=js&"
export * from "./PreventGreenhouse.vue?vue&type=script&lang=js&"
import style0 from "./PreventGreenhouse.vue?vue&type=style&index=0&id=fbb96a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb96a58",
  null
  
)

export default component.exports